import { render } from "./QuizFieldWrapper.vue?vue&type=template&id=3f6c80d6&scoped=true"
import script from "./QuizFieldWrapper.vue?vue&type=script&lang=js"
export * from "./QuizFieldWrapper.vue?vue&type=script&lang=js"

import "./QuizFieldWrapper.vue?vue&type=style&index=0&id=3f6c80d6&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6c80d6"]])

export default __exports__